module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_07_dis.0fd0f46f.png";